"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const polling_1 = require("./polling");
const websocket_1 = require("./websocket");
exports.default = {
    polling: polling_1.Polling,
    websocket: websocket_1.WebSocket,
};
